
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: 'Authenticate with Plaid, Pay with Silicon Valley Bank'
};
export const partnerProps = {
  partner: 'Silicon Valley Bank',
  imagePartnerName: 'svb',
  clientLibrary: 'svb_api',
  subtitle: metadata.description,
  registrationUrl: 'https://www.svb.com/account/fintech/plaid-integration',
  apiUrl: 'https://www.svb.com/account/fintech/plaid-integration/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`The Silicon Valley Bank (SVB) and Plaid integration helps reduce risk, administrative work and costs of processing payments. This solution connects Plaid's instant account verification and SVB's ACH API functionality via a tokenized integration to help minimize the handling of clients' bank and payments data.`}</p>
    <p>{`Together, the Plaid and SVB integration helps give clients an efficient way to process payments directly from a bank. SVB supports instant account verification for both ACH Debits and ACH Credits.`}</p>
    <p>{`If you have an SVB ACH API-enabled account with Plaid, view the guide to begin setting up the integration. If you do not have an account with the SVB ACH API but need additional information, visit the following `}<a parentName="p" {...{
        "href": "https://www.svb.com/account/fintech/plaid-integration/"
      }}>{`SVB website`}</a>{` for more information.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
